import { Component, OnInit } from '@angular/core';
import { AdminLanguageService } from '../services/admin-language-service/admin-language.service';
import {UserLanguageService} from '../services/user-language-service/user-language.service';

@Component({
    selector: 'additonal-page',
    templateUrl: './additonal-page.component.html',
    styleUrls: ['./additonal-page.component.scss'],
    standalone: false
})
export class AdditonalPageComponent implements OnInit {
  labelsSub; Subscription
  labels
  constructor(private userLanguageService: UserLanguageService) { }

  ngOnInit(): void {
    this.labelsSub = this.userLanguageService.labels$.subscribe((labels) => {
      this.labels = labels;
    })
  }

}
